export const INFO = "info";
export const SUCCESS = "success";
export const WARNING = "warning";
export const ERROR = "error";

export const ACTIVE = "active";
export const DISMISSED = "dismissed";
